import { Flex, Tag } from 'antd'

import { CheckCircleOutlined, CheckOutlined, MinusCircleOutlined, WarningOutlined } from '@ant-design/icons'

export const SubscriptionStatus = ({ status }: { status: 'ACTIVE' | 'INACTIVE' | 'CANCELLED' | 'COMPLETED' }) => {
    const presets = {
        CANCELLED: {
            icon: <MinusCircleOutlined />,
            color: 'red',
            label: 'Cancelled'
        },
        INACTIVE: {
            icon: <WarningOutlined />,
            color: 'orange',
            label: 'Inactive'
        },
        ACTIVE: {
            icon: <CheckOutlined />,
            color: 'green',
            label: 'Active'
        },
        COMPLETED: {
            icon: <CheckCircleOutlined />,
            color: 'black',
            label: 'Completed'
        }
    }

    if (!['ACTIVE', 'INACTIVE', 'CANCELLED', 'COMPLETED'].includes(status)) {
        return null
    }

    return (
        <Flex gap="small" align="center" wrap justify="space-around">
            <Tag key={status} color={presets[status].color} icon={presets[status].icon} variant="outlined">
                {presets[status].label}
            </Tag>
        </Flex>
    )
}
